<span class="title">
  PRIMAS ESPORÁDICAS
  <svg-icon
    class="icon"
    app-tooltip="Prima en exceso a la prima periódica, opcional, que el contratante puede pagar en cualquier momento para aumentar su Valor póliza."
    position="right"
    src="../../../../../assets/icons/information-right.svg"
    [svgStyle]="{
      'width.rem': 0.93,
      'height.rem': 0.87,
      position: 'relative',
      'left.rem': 0.15
    }"
  ></svg-icon>
</span>
<span class="subtitle">
  Ingresa el monto de aporte a realizar y medio de pago:
</span>
<div class="container-form">
  <app-form-lablel [label]="'Monto'"></app-form-lablel>
  <div class="row">
    <div class="left container-aportes-input custom-input-text">
      <mat-form-field
        *ngIf="pagoStyle"
        class="left-align anchoInput"
        appearance="outline"
      >
        <input
          class="width-auto"
          #inputMonto
          mask="dot_separator"
          prefix="$ "
          matInput
          [(ngModel)]="monto"
        />
      </mat-form-field>
      <mat-form-field
        *ngIf="!pagoStyle"
        class="left-align anchoAportes"
        appearance="outline"
      >
        <input
          class="width-auto"
          #inputMonto
          mask="dot_separator"
          prefix="$ "
          matInput
          [(ngModel)]="monto"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="left container-aportes-input custom-input-text">
      <mat-form-field class="left-align anchoInput" appearance="outline">
        <mat-select
          class="width-auto"
          (selectionChange)="onChangeElegirMedioPago($event)"
          [(ngModel)]="comboMedioPago"
          placeholder="Seleccionar medio de pago"
          [disabled]="medioDisable"
        >
          <mat-option [value]="2">
            Tarjeta de Débito
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="right">
      <button
        *ngIf="pagoStyle"
        class="abonarButton"
        [disabled]="!monto || monto <= 0 || !medio || medio < 0"
        mat-flat-button
        (click)="onRealizarTraslado()"
      >
        Abonar
      </button>
    </div>
  </div>
</div>

<div class="container-message" *ngIf="message && monto && monto > 0">
  <mat-icon>
    info
  </mat-icon>
  <label>
    {{ message }}
  </label>
</div>
